import { OUTSIDE_DOMAINS } from '../../app.constants';

export const isInstanceRequest = (url: string): boolean => !OUTSIDE_DOMAINS.find((domain: string) => url.includes(domain));
